<template>
  <div class="layout">
    <PageHeader></PageHeader>
    <PageMain></PageMain>
    <PageFooter></PageFooter>
  </div>
</template>

<script>
import PageHeader from "./components/pageHeader";
import PageMain from "./components/pageMain";
import PageFooter from "./components/pageFooter";
export default {
  components: {
    PageHeader,
    PageMain,
    PageFooter,
  },
  created() {
    // this.$router.push("/home")
  },
};
</script>

<style lang="scss" scoped>
.layout {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>